import {Col, RowDivFooter} from "../styled";
import  {useForm} from "react-hook-form";
import FBServices from "../FBServices";


let className = 'row'
const Footer = () => {
    const {register, handleSubmit} = useForm();
    const onFieldSubmit = data => {
        console.log(data);
        FBServices.createEntry(data.newTrigger);
    };
    const onErrors = errors => console.error(errors);
    return(

        <RowDivFooter className={className}>
            <form onSubmit={handleSubmit(onFieldSubmit)}>
                <input type="text" name="newTrigger" {...register('newTrigger')} />
                <button>Submit</button>
            </form>
        </RowDivFooter>
        );
}

export default Footer;